function ReportsCtrl(toaster, $stateParams, ReportsService, AppSettings, OrganizationService) {
  'ngInject';

  const vm = this;
  vm.reportsForm = {};
  vm.reports = [];
  vm.loading = false;
  vm.dataloading = false;
  vm.btndisabled = false;
  vm.responseReceived = false;
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.reportsForm.todate = !$stateParams.todate ? '' : $stateParams.todate;
  vm.reportsForm.fromdate = !$stateParams.fromdate ? '' : $stateParams.fromdate;
  vm.reportExportId = !$stateParams.reportExportId ? '' : $stateParams.reportExportId;
  vm.sortByReports = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.rowPerPageOptions = ['50', '100', '200'];
  vm.sortFlag = false;
  vm.regex = '^[-+]?[0-9]*\.?[0-9]+$';
  vm.dateRegex = AppSettings.dateRegex;
  vm.yearMonthRegex = AppSettings.yearMonthRegex;
  vm.isReportsPendingJobs = false;
  vm.refreshLinkParams = {
    show_ytd: false,
    show_total: false,
    prior_periods: 3,
    date: '',
    benchmark: false
  };
  vm.dateSelect = {};
  vm.clientError = false;
  vm.selectedClients = [];
  vm.clients = [{
    id: 0,
    email: 'All'
  }];
  vm.disableChoices = false;
  vm.emailRegex = "(^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+.)+[A-Za-z]{2,})|(?<![\w\d])All(?![\w\d])"; //Allows email or  'All'

  vm.init = function () {
    vm.url = `/organizations/${$stateParams.orgId}/report_exports.json?page=${vm.pageNumber}&size=${vm.size}&by_report_export_id=${vm.reportExportId}&by_from=${vm.reportsForm.fromdate}&by_to=${vm.reportsForm.todate}&sort=${vm.sortByReports}`;
    vm.loading = true;
    vm.dataloading = true;
    if ($stateParams.orgId) {
      ReportsService.getReportExports($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
        vm.loading = false;
        vm.dataloading = false;
        if (response.status == 200) {
          vm.reportsResponse = response.data;
          vm.currentPage = !vm.reportsResponse.pagination ? 1 : vm.reportsResponse.pagination.current_page;
          vm.totalPages = !vm.reportsResponse.pagination ? 1 : vm.reportsResponse.pagination.total_pages;
          vm.reportExports = response.data.report_exports;
          vm.setRefreshParams();
        }
      });
      OrganizationService.getAssignedUsers($stateParams.orgId, function (response) {
        if (response.status == 200) {
          vm.clients = vm.clients.concat(response.data.users);
        }
      });
    }
    //vm.reportsPending();
  };

  vm.setRefreshParams = function () {
    let data = vm.reportExports[0];
    vm.refreshLinkParams = {
      show_ytd: data.export_options.show_ytd,
      show_total: data.export_options.show_total,
      prior_periods: data.export_options.prior_periods,
      date: data.report_date,
      benchmark: data.export_options.benchmark
    };
  };

  vm.emailToClient = function () {
    if (vm.selectedClients.length <= 0) {
      vm.clientError = true;
    } else {
      vm.selectedClients = vm.selectedClients.map(x => x.email); // selects only emails
      ReportsService.emailProfitAndLoss($stateParams.orgId, vm.reportExports[0].id, vm.selectedClients, function (response) {
        vm.disableChoices = false;
        if (response.status == 200){
          vm.clientError = false;
          vm.selectedClients = [];
          $('#emailModal').modal('hide');
          if (response.data.status == 'success') {
            toaster.pop('success', 'Income Statement email is being sent to client. It may take a while.');
          } else{
            toaster.pop('error', 'Refresh report before sending email to client.');
          }
        }
      });
    }
  };

  vm.loadClients = function (item) {
    var clientList = [];
    if (item == '' && !vm.disableChoices) {
      clientList = vm.clients;
    } else if (vm.disableChoices) {
      clientList = [];
    } else {
      for (var i = 0, len = vm.clients.length; i < len; i++) {
        var clientEmail = vm.clients[i].email;
        if (clientEmail.includes(item)) {
          clientList.push(vm.clients[i]);
        }
      }
    }

    return clientList;
  };

  vm.onClientSelection = function (item) {
    vm.clientError = false;
    var results = item.email.match(vm.emailRegex);
    if (!results) {
      vm.selectedClients.pop();
    }
    if (item.id == 0) {
      if (!vm.disableChoices) {
        // Removes other selected options except manually typed emails if All is selected
        vm.selectedClients = vm.selectedClients.filter(x => x.id == undefined);
        vm.selectedClients = vm.selectedClients.concat({
          id: 0,
          email: 'All'
        });
      }
      vm.disableChoices = !vm.disableChoices;
      vm.loadClients('');
    }
  };

  vm.exportProfitAndLoss = function () {
    ReportsService.exportProfitAndLoss($stateParams.orgId, vm.refreshLinkParams, function (response) {
      vm.mapping = response.data.mapping;
      if(response.status == 200){
        toaster.pop('success', response.data.message);
      }
    });
  };

  vm.onPikadaySelect = function (pikaday) {
    vm.refreshLinkParams.date = pikaday.toString('YYYY-MM');
  };

  vm.onPikadayOpen = function (pikaday) {
    vm.dateSelect.setMaxDate(new Date());
  };

  vm.emailView = function () {
    vm.clientError = false;
    vm.selectedClients = [];
    vm.disableChoices = false;
    $('#emailModal').modal('show');
  };
}


export default {
  name: 'ReportsCtrl',
  fn: ReportsCtrl
};
